"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Upload;

var _react = _interopRequireDefault(require("react"));

var _SvgIconWrap = _interopRequireDefault(require("../../../components/SvgIcon/SvgIconWrap"));

function Upload(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIconWrap.default, props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.6625,16.16875 L3.6625,4.49625 C3.6625,3.1205625 4.7880625,1.995 6.16375,1.995 L17.83625,1.995 C19.2119375,1.995 20.3375,3.1205625 20.3375,4.49625 L20.3375,16.16875 C20.3375,17.5444375 19.2119375,18.67 17.83625,18.67 L14.50125,18.67 L14.50125,17.0025 L17.83625,17.0025 C18.2948125,17.0025 18.67,16.6273125 18.67,16.16875 L18.67,4.49625 C18.67,4.0376875 18.2948125,3.6625 17.83625,3.6625 L6.16375,3.6625 C5.7051875,3.6625 5.33,4.0376875 5.33,4.49625 L5.33,16.16875 C5.33,16.6273125 5.7051875,17.0025 6.16375,17.0025 L9.49875,17.0025 L9.49875,18.67 L6.16375,18.67 C4.7880625,18.67 3.6625,17.5444375 3.6625,16.16875 Z M8.081375,11.749875 C8.414875,12.083375 8.93596875,12.083375 9.26946875,11.749875 L11.1870937,9.83225 L11.1870937,21.17125 L11.1870937,21.17125 C11.1870937,21.6298125 11.5622812,22.005 12.0208437,22.005 C12.4794062,22.005 12.8545937,21.6298125 12.8545937,21.17125 L12.8545937,9.85309375 L14.7722187,11.7707188 C15.1057187,12.1042188 15.6268125,12.1042188 15.9603125,11.7707188 C16.2938125,11.4372187 16.2938125,10.916125 15.9603125,10.582625 L12.6253125,7.247625 C12.4377187,7.080875 12.2292812,6.9975 12,6.9975 C11.7707187,6.9975 11.5622812,7.080875 11.416375,7.247625 L8.081375,10.582625 C7.747875,10.8952813 7.747875,11.4372187 8.081375,11.749875 Z"
  }));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud-fe/react-components/lib/components/Upload/icons/Upload.js
// module id = 2011
// module chunks = 6 7 17 18